import React from 'react';
export function UrgencyBanner() {
  return <div className="relative z-[70] border-b border-[#e6a45c]/30 bg-[#c65a2e] px-4 py-2.5 text-center text-sm font-bold text-white md:py-3" data-id="element-344" data-mp="3l3xq2oryrev5">
      <p data-id="element-345" data-mp="2niy87kcsoqvw"><span className="mr-2" data-id="element-346" data-mp="2ni51ukhr03ea">⛰</span>Programa digital para principiantes · Empezá a tu ritmo y con mejores decisiones</p>
    </div>;
}